import React from 'react';
import {Col, Container, Row} from 'reactstrap';
import {Location} from '@reach/router';

import useBeacon from 'utils/useBeacon';
import useBalanceText from 'utils/useBalanceText';

import PageMeta from 'components/PageMeta';
import SectionCL from 'components/ComponentLibrary/SectionCL';
import Footer from 'components/Footer';

export default function (props) {
  return <Location>{({location}) => <ChallengeWelcomeWLC location={location} {...props} />}</Location>;
}

function ChallengeWelcomeWLC({
  pageTitle = 'Welcome to the Eat The Rainbow Challenge',
  pageDescription = 'Join thousands of individuals saying YES to adding more color to their plates for increased nutrients.',
  ogUrl = 'https://wlc.foodrevolution.org/challenge/',
  ogImage = 'https://s3.us-west-2.amazonaws.com/cdn.foodrevolution.org/wlc/challenge/og/wlc-lc-202504-open-graph-challenge.png',
  location = {},
  ...props
}) {
  useBeacon();
  useBalanceText();
  return (
    <div className="page page-nosocial d-flex flex-column">
      <PageMeta title={pageTitle} description={pageDescription} ogImage={ogImage} url={ogUrl} />
      <div className="page-content d-flex flex-column flex-grow-1">
        <SectionCL
          id="welcome-header"
          color="light-gray"
          className="text-center text-white flex-grow-1"
          innerWrapClass="d-flex flex-column flex-grow-1"
          innerClass="py-5 my-auto"
          angle="none"
          imgUrl="https://cdn.foodrevolution.org/eattherainbow/images/1129818010-lg.jpg"
        >
          <Container>
            <Row>
              <Col>
                <div className="background-black-90 rounded p-4 p-lg-5">
                  <h2 className="section-heading">Thank You for Joining the Free Eat the Rainbow Challenge!</h2>
                  <p className="text-h5">
                    We’re going to share an amazing event together! Head over to your email inbox, because in a few
                    minutes, you’ll receive an email with all of the information you need to know to participate in the
                    Challenge!
                  </p>
                  <p className="text-h5">We can’t wait 🌱</p>
                </div>
              </Col>
            </Row>
          </Container>
        </SectionCL>
      </div>
      <Footer className="mt-auto" />
    </div>
  );
}
